/*
WE SHOULD REALLY DO THIS IMPLEMENTATION INSTEAD
https://www.drupal.org/node/2269515

*/
Element.prototype.signUpConsumerForm = () => {

    const testRegex = (r) => (x) => r.test(x);
    jQuery.validator.addMethod('validEmail', testRegex(/^(([0-9a-zA-Z])+([-._'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/));
    var response;
    function getState(){
        return jQuery.ajax({
            url: '/api/verify-zipcode?zipcode=' + document.getElementById('edit-mailing-address-postal-code').value + '&state=' + document.querySelector('select#edit-mailing-address-state-province').value,
            type: 'POST',
            data: 'JSON',
            async: false,
            success: function (data, textStatus, jqXHR) {
                response = (data.valid == true) ? true : false;
            }
        });
    }
   
    jQuery.validator.addMethod('validState',
        function () {
            jQuery('select#edit-mailing-address-state-province').on('change', function(){
                jQuery('input#edit-mailing-address-postal-code').valid();
            });
            getState();
            return response;
        }
    );
    jQuery('.f-Consumer').validate({
        rules: {
            registrant_type: "required",
            first_name: {
                required: true,
                maxlength: 50,
            },
            last_name: {
                required: true,
                maxlength: 50,
            },
            email: {
                required: true,
                validEmail: true,
                maxlength: 75,
            },
            "zip_code[postal_code]": {
                required: true,
                digits: true,
                minlength: 5,
                maxlength: 5,
            },
            phone_number: {
                required: "#edit-sms-kit-sms-kit:checked",
                maxlength: 12,
                phoneUS: true,
            },
            nayzilam_use_status: "required",
            "mailing_address[address]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                maxlength: 75,
            },
            "mailing_address[address_2]": {
                maxlength: 75,
            },
            "mailing_address[city]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                maxlength: 50,
            },
            "mailing_address[state_province]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
            },
            "mailing_address[postal_code]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                digits: true,
                minlength: 5,
                maxlength: 5,
                validState: true,
                // validState: {
                //     remote: {
                //         url: '/api/verify-zipcode?zipcode=' + document.getElementById('edit-mailing-address-postal-code').value + '&state=' + document.getElementById('edit-mailing-address-state-province').value,
                //         type: 'POST',
                //         async: false,
                //         data: {
                //             zipcode: function () {
                //                 return response = (data.valid == true) ? true : false;
                //             }
                //         }
                //     }
                // },
            },
        },
        messages: {
            registrant_type: "Please confirm if you are a patient or a caregiver.",
            first_name: "Please provide your first name.",
            last_name: "Please provide your last name.",
            email: {
                "required": "Please provide your email address.",
                "validEmail": "Please enter a valid email address.",
            },
            "zip_code[postal_code]": "Please enter a valid ZIP code (e.g., 12345).",
            phone_number: "Please provide a valid phone number.",
            nayzilam_use_status: "Please select the statement that best describes you or the person you are representing.",
            "phone_number": "Please specify a valid phone number.",
            "mailing_address[address]": "Please provide your mailing address.",
            "mailing_address[city]": "Please provide your city.",
            "mailing_address[state_province]": {
                required: "Please provide your state.",
            },
            "mailing_address[postal_code]": {
                required: "Please enter a valid ZIP code (e.g., 12345).",
                validState: "Please provide the correct ZIP code for your selected state.",
            },
        },
        errorPlacement: function (error, element) {
            let wrapper;
            if (element[0].name === 'nayzilam_use_status' || element[0].name === 'registrant_type') {
                wrapper = element.closest("fieldset")
            } else {
                wrapper = element.closest("fieldset, div.form-item")
            }
            // console.log(element, wrapper)
            error.appendTo(wrapper);
        },
        errorClass: 'f-Form_Error',
    });

    jQuery('#edit-phone-number').keyup(function(){
        jQuery(this).val(jQuery(this).val().replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3'));
    });

}


// Only run the function whenever there is an instance of a Eligibility Tool
if (document.querySelector('.f-Consumer')) {
    jQuery(document).ready(function () {
        let zipCode = document.querySelector('input#edit-zip-code-postal-code');;
        let maZip = document.querySelector('input#edit-mailing-address-postal-code');
        const checkBox = document.querySelector('input#edit-direct-mail-options-welcome-kit');
        const checkBox2 = document.querySelector('input#edit-direct-mail-options-training-kit');
        
        var populateZipcode = function (zipcode) {
            if (zipcode !== '') {
                zipcode.setAttribute('value', zipcode.value);
                maZip.setAttribute('value', zipcode.value);
                maZip.value = zipcode.value;
            }
        };
        if ( zipCode ) {
            jQuery('input#edit-mailing-address-postal-code').one('input keyup blur', function () { 
                populateZipcode(zipCode); 
                checkBox.addEventListener('click', populateZipcode(zipCode));
                checkBox2.addEventListener('click', populateZipcode(zipCode));
                maZip.setAttribute('aria-invalid', 'false');
                maZip.classList.add('valid');
            });
        }
    });
    document.querySelector('.f-Consumer').signUpConsumerForm();
    populateEpilepsyCookie();

}